export const ArchieAuthTheme = {
  a: {
    color: "#01bfd8",
    fontWeight: "bold",
    cursor: "pointer",
  },
  button: {
    marginTop: "15px",
    padding: "10px",
    cursor: "pointer",
    borderRadius: "2rem",
    border: "0.125rem solid #00bfd8",
    color: "#fff",
    backgroundColor: "#00bfd8",
    textTransform: "uppercase",
  },
  input: {
    marginBottom: "15px",
    padding: "10px",
  },
  inputLabel: {
    marginTop: "15px",
  },
  sectionFooterSecondaryContent: {
    marginTop: "20px",
    display: "block",
  },
  signInButton: {
    display: "flex",
    alignItems: "center",
    cursor: "pointer",
  },
  oAuthSignInButton: {
    display: "none"
  },
  googleSignInButton: {
    backgroundColor: "#4285f4",
    color: "#ffffff",
    border: 0,
    borderRadius: "2rem",
    height: "1rem",
    padding: 20,
  },
  signInButtonIcon: {
    display: "inline-block",
    height: 20,
    width: 20,
    marginRight: 10,
  },
  container: {
    marginTop: 30
  }
}

export default ArchieAuthTheme
